'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slick = void 0;
const lodash_1 = require("lodash");
const $ = require("jquery");
require("slick-carousel");
class Slick {
    constructor() {
        if ($('.bulletBusinessSlick').length > 0) {
            this.switchSlick();
            $(window).on('resize', (0, lodash_1.throttle)((e) => {
                this.switchSlick();
            }, 1000));
        }
    }
    // Slick切り替え
    switchSlick() {
        const OVER_PC_SIZE = 1200;
        const browserWidth = $(window).outerWidth();
        if (OVER_PC_SIZE >= browserWidth) {
            this.createSlick();
        }
        else {
            this.cancelSlick();
        }
    }
    // Slick生成
    createSlick() {
        $('.bulletBusinessSlick').not('.slick-initialized').slick({
            asNavFor: '.bulletBusinessSlickNavi',
            dots: false,
            autoplay: true,
            slidesToShow: 1,
            variableWidth: false
        });
        $('.bulletBusinessSlickNavi').not('.slick-initialized').slick({
            arrows: true,
            asNavFor: '.bulletBusinessSlick',
            slidesToShow: 1
        });
    }
    // Slick解除
    cancelSlick() {
        $('.bulletBusinessSlick.slick-initialized').slick('unslick');
        $('.bulletBusinessSlickNavi.slick-initialized').slick('unslick');
    }
}
exports.Slick = Slick;
exports.default = Slick;
